import React from 'react';
import WidgetList from './WidgetList';
import { withLocalize } from 'react-localize-redux';
import { Translate } from 'react-localize-redux';

  function HomePage(props) {
    let langCode = "en";
    if (props.activeLanguage !== undefined) {
      langCode = props.activeLanguage.code;
    }
     return (
      
      <WidgetList ID={props.ID}/>
    );
  }
  export default withLocalize(HomePage);


// WEBPACK FOOTER //
// ./src/pages/Home/HomePage.js